import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

const baseString = 'vra-explainer';
const classString = classNames({
  [`${baseString}`]: true,
  'vra-planting-plan-form__caption': true
});


const Explainer = ({
  children,
  isVisible=true
}) => isVisible ? (
  <aside className={classString}>
    {children}
  </aside>
) : null;

Explainer.propTypes = {
  children: propTypes.node.isRequired,
  isVisible: propTypes.bool
};

export default Explainer;
